import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Overline } from '../../../components/Typography';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../../../assets/svg/home-icon.svg';
import { ReactComponent as FlaskIcon } from '../../../assets/svg/flask-icon.svg';
import { ReactComponent as BagIcon } from '../../../assets/svg/bag-icon.svg';
import { ReactComponent as HeartIcon } from '../../../assets/svg/heart-icon.svg';
import { ReactComponent as PlannerIcon } from '../../../assets/svg/planner-icon.svg';
import { LAB_TESTS_URL } from '../MyHealthHeaderNavbar';

import './index.scss';

const NavbarBottom = ({ data }) => {
  const [numberOfResultsNotViewed, setNumberOfResultsNotViewed] = useState(0);
  const [isScrolledUp, setIsScrolledUp] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const totalScrollableHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (currentScrollY > 0) {
        setIsScrolledUp(true);
      }

      if (currentScrollY >= totalScrollableHeight) {
        setIsScrolledUp(false);
      }
    };

    if (window.scrollY > 0) {
      setIsScrolledUp(true);
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (data && data.tests) {
      const getResultsViewedStatus = test => {
        if (test.resultsViewed === null || test.resultsViewed === undefined) {
          return true;
        }
        return test.resultsViewed;
      };
      const countResultsNotViewed = () => {
        return data.tests.filter(test => getResultsViewedStatus(test) === false)
          .length;
      };
      setNumberOfResultsNotViewed(countResultsNotViewed());
    } else {
      setNumberOfResultsNotViewed(0);
    }
  }, [data]);

  return (
    <div
      className={cx({
        'navbar-bottom': true,
        'navbar-bottom--scrolled-up': isScrolledUp
      })}
    >
      <NavLink
        to='/myhealth'
        end
        className={({ isActive }) =>
          isActive
            ? 'navbar-bottom__link navbar-bottom__active-link'
            : 'navbar-bottom__link'
        }
      >
        <HomeIcon />
        <Overline element='p'>
          <FormattedMessage id='dashboard.home' defaultMessage='Home' />
        </Overline>
      </NavLink>

      <NavLink
        to='/myhealth/products'
        end
        className={({ isActive }) =>
          isActive
            ? 'navbar-bottom__link navbar-bottom__active-link'
            : 'navbar-bottom__link'
        }
      >
        <FlaskIcon />
        <Overline element='p'>
          <FormattedMessage
            id='dashboard.my-products'
            defaultMessage='My products'
          />
        </Overline>

        {numberOfResultsNotViewed > 0 && (
          <div className='navbar-bottom__bubble'>
            <Overline className='navbar-bottom__number-of-unviewed-results'>
              {numberOfResultsNotViewed}
            </Overline>
          </div>
        )}
      </NavLink>

      {data && data.employeeBenefits && (
        <NavLink
          to='/myhealth/employee-health'
          end
          className={({ isActive }) =>
            isActive
              ? 'navbar-bottom__link navbar-bottom__active-link'
              : 'navbar-bottom__link'
          }
        >
          <HeartIcon className='navbar-bottom__heart-icon' />
          <Overline element='p'>
            <FormattedMessage
              id='dashboard.employee-health'
              defaultMessage='Employee Health'
            />
          </Overline>
        </NavLink>
      )}

      <NavLink
        to='/myhealth/check-up'
        end
        className={({ isActive }) =>
          isActive
            ? 'navbar-bottom__link navbar-bottom__active-link'
            : 'navbar-bottom__link'
        }
      >
        <PlannerIcon />
        <Overline element='p'>
          <FormattedMessage
            id='dashboard.checkup-planner'
            defaultMessage='Check-up Planner'
          />
        </Overline>
      </NavLink>

      <a
        href={LAB_TESTS_URL}
        className='navbar-bottom__link'
        target='_blank'
        rel='noreferrer'
      >
        <BagIcon />
        <Overline element='p'>
          <FormattedMessage id='dashboard.shop' defaultMessage='Shop' />
        </Overline>
      </a>
    </div>
  );
};

NavbarBottom.propTypes = {
  data: PropTypes.object
};

const mapStateToProps = state => ({
  data: state.dashboard.get('data')
});

export default connect(mapStateToProps)(NavbarBottom);
